import { useEffect, useState } from 'react'

import { useToast } from '@wartek-id/toast'

import Rate from './Rate'
import { useApiPutRate } from 'api/cerita-praktik/useAPICeritaPraktik'
import { useSETrackEvent } from '../hooks/useSETrackEvent'

import type { ICeritaPraktikRateValue } from 'types/cerita-praktik'
import type { FC } from 'react'
import type { IRateOption, IRateOptions } from './Rate'

import SmileyNeutral from 'assets/icons/smiley-0.svg'
import SmileyHappy from 'assets/icons/smiley-1.svg'

interface RateWrapperProps {
  id: string
  rating?: ICeritaPraktikRateValue | undefined
}

const RateWrapper: FC<RateWrapperProps> = ({ id, rating }) => {
  const toast = useToast()
  const { SETrackRate } = useSETrackEvent()
  const iconStyle = { width: 36, height: 36 }
  const [options, setOptions] = useState<IRateOptions>([
    {
      label: 'Tidak',
      value: 'RT_NEGATIVE',
      icon: <SmileyNeutral style={iconStyle} />,
      selected: false,
    },
    {
      label: 'Ya',
      value: 'RT_POSITIVE',
      icon: <SmileyHappy style={iconStyle} />,
      selected: false,
    },
  ])

  const { mutate: mutateRate, isLoading: isMutationSubmitting } = useApiPutRate(
    id,
    {
      useErrorBoundary: false,
      onError() {
        toast({
          message: 'Gagal mengirim jawaban. Mohon coba beberapa saat lagi',
        })
        // Reset on failure
        select()
      },
      onSuccess() {
        toast({
          message: 'Jawaban berhasil terkirim!',
          type: 'success',
        })
      },
    }
  )

  const select = (selectedValue?: IRateOption['value']) => {
    const ratingOptions = Object.keys(options).map((index) => {
      const option = options[index]
      if (selectedValue && option.value === selectedValue)
        return { ...option, selected: !option.selected }
      return { ...option, selected: false }
    })
    setOptions(ratingOptions)
  }

  const onRateSelect = (selectedOption: IRateOption) => {
    // Select the selected option
    select(selectedOption.value)

    // Send rate value to API
    mutateRate({ rating: selectedOption.value })

    // Track rating
    SETrackRate({
      rating: selectedOption.value === 'RT_POSITIVE' ? 'USEFUL' : 'NOT_USEFUL',
    })
  }

  useEffect(() => {
    // Pre-populate rate based on previous rate
    if (rating) select(rating)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rating])

  return (
    <div data-testid="cp-rate-wrapper">
      <Rate
        title="Apa Ide Praktik ini membantu?"
        description="Jawaban Anda tidak diberikan ke penulis"
        options={options}
        className="mx-2"
        isSubmitting={isMutationSubmitting}
        onSelect={(option) => onRateSelect(option)}
      />
    </div>
  )
}
export default RateWrapper
